import { faTimes } from "@jewlr/pro-regular-svg-icons/faTimes"
import PropTypes from "prop-types"
import { useCallback } from "react"
import { useDispatch } from "react-redux"

import { removeFromCart } from "app-store-v2/header/actions"
import { ItemTitle } from "areas/cart/components"
import {
  CardProductImageContainer,
  RemoveItem,
} from "areas/cart/line-item/components"
import Price from "areas/cart/line-item/jewlr/price"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"

const BoxAddonImage = ({ boxAddon, item }) => {
  return boxAddon.image_url?.startsWith("https://user-uploads.jewlr.com") ? (
    <Image
      alt={boxAddon.title}
      className="mx-auto block bg-black p-8"
      data-cy={`cart-line-item-box-img-${item.style_code}`}
      height={120}
      src={boxAddon.image_url}
      title={boxAddon.title}
      width={120}
    />
  ) : (
    <Image
      alt={boxAddon.title}
      className="w-(--base-width) desktop:w-(--desktop-width)"
      height={325}
      src={boxAddon.image_url}
      width={325}
    />
  )
}

BoxAddonImage.propTypes = {
  boxAddon: PropTypes.object,
  item: PropTypes.object,
}

const Addon = ({ item, setOnRemoveAction }) => {
  const dispatch = useDispatch()
  const boxAddon = (item?.addons || []).find(
    (addon) => addon.addon_type === "BOX_PRINT"
  )

  const handleRemoveClick = useCallback(() => {
    if (boxAddon) {
      setOnRemoveAction(() => () => dispatch(removeFromCart(boxAddon.id, true)))
    }
  }, [boxAddon, dispatch, setOnRemoveAction])

  if (!boxAddon) return null

  return (
    <div className="desktop:gap-24 desktop:mt-40 relative my-24 flex gap-16">
      <CardProductImageContainer>
        <BoxAddonImage boxAddon={boxAddon} item={item} />
      </CardProductImageContainer>
      <div className="flex-1">
        <ItemTitle>{boxAddon.title}</ItemTitle>
        <Price item={boxAddon} type="addon" />
      </div>
      <RemoveItem
        aria-label={`Remove ${boxAddon.title} addon from ${jewlr_t("Cart")}}`}
        data-cy={`cart-remove-btn-${boxAddon.addon_code}`}
        onClick={handleRemoveClick}
      >
        <FontAwesomeIcon className="text-12" icon={faTimes} />
      </RemoveItem>
    </div>
  )
}

Addon.propTypes = {
  item: PropTypes.object,
  setOnRemoveAction: PropTypes.func,
}

export default Addon
